import { css } from "@emotion/react";

// TODO: スタイルは全て仮実装
export const root = css`
  display: grid;
  row-gap: 20px;
`;

export const variantStyle = css`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
`;

export const variantCardStyle = css`
  border-style: solid;
  border-width: 1px;
  display: inline-block;
  padding: 20px;
  white-space: nowrap;

  & input {
    display: none;
  }
`;

export const notSelectedVariantCardStyle = css`
  background-color: #fff;
  border-color: #aaa;
  cursor: pointer;
`;

export const selectedVariantCardStyle = css`
  background-color: #aaa;
  border-color: #000;
`;
